export enum DraftStatus {
  Deleted = 'Deleted',
  Draft = 'Draft',
  Published = 'Published',
}
